import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/BSB 300.avif';
import networkImage from '../pictures/Network.webp';
import shopImage from '../pictures/Modern Shop with People.png';

export function BSB300() {
  return (
    <MarketingArticle
      title="BSB 300"
      kicker="Network-ready generator"
      description="A planned Back-Step Blockchain system for organizations that need a stronger deployment option with network connectivity."
      path="/products"
      heroImage={heroImage}
      heroAlt="BSB 300 hardware concept"
      primaryAction={{ to: '/contact', label: 'Register interest' }}
      secondaryAction={{ to: '/products', label: 'Back to products' }}
      sections={[
        {
          tag: 'Use case',
          title: 'A stronger platform for customer-facing trust services.',
          image: networkImage,
          imageAlt: 'Network infrastructure concept',
          paragraphs: [
            'BSB 300 is aimed at organizations that need more than a starter module: better integration, networked operation, and a clearer path toward production service.',
            'It is suitable for branded trust services, controlled pilots, and applications where customer access and operational reliability matter.',
          ],
        },
        {
          tag: 'Market value',
          title: 'Turn trusted records into a visible customer benefit.',
          image: shopImage,
          imageAlt: 'Customers in a modern shop',
          paragraphs: [
            'The business value is not the hardware itself. It is the confidence customers gain when product data, certificates, and important events can be verified.',
            'We can discuss availability, pilot scope, and deployment requirements with qualified partners.',
          ],
        },
      ]}
    />
  );
}
